module.exports = __webpack_public_path__ + "media/images/help/step1-2-43cb05d4c9d07c8ee68f36d6d74beb44.png";